import { Experiment, Result } from '@growthbook/growthbook'
import { sendGrowthExperiment } from '@infrastructure/GoogleTagManager/GA4Events/Growthbook'

import { Variant } from './index'

export const growthbookTrackingCallback = (experiment: Experiment<Variant>, result: Result<Variant>): void => {
    sendGrowthExperiment(experiment.key, result.key)
}
